const upload = (request, api_config) => {
  const prefix = "Govern";

  const AnalysisUpload = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/AnalysisUpload`,
      method: "post",
      data: data,
    });
    return result;
  };

  return {
    AnalysisUpload,
  };
};

export default upload;
